var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletTopicPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "11px",
    viewBox: "0 0 6 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5229\\u7528\\u6848\\u5185",
    transform: "translate(-74.000000, -212.000000)",
    fill: "#888888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4497475,4 L68.4497475,5 L62.4497475,5 L62.4497475,11 L61.4497475,11 L61.4497475,4 L68.4497475,4 Z",
    id: "Combined-Shape",
    transform: "translate(64.949747, 7.500000) rotate(-225.000000) translate(-64.949747, -7.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletTopicPath);
export default __webpack_public_path__ + "static/media/bullet-topicPath.9dd4937e680c3e2e32d4711cc9a9da8e.svg";
export { ForwardRef as ReactComponent };